import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCurrentLabelsJson } from '../../store/labels';
import { getIndicativeRateCountry } from '../../store/service-options';
import { Observable } from 'rxjs';
import { Labels } from '../../app.models';

@Component({
  selector: 'app-indicative-rate-note',
  templateUrl: './indicative-rate-note.component.html',
  styleUrls: ['./indicative-rate-note.component.scss'],
})
export class IndicativeRateNoteComponent implements OnInit {
  public indicativeRateCountry$: Observable<boolean> | undefined;
  indicativeRateCountry!: boolean;
  labels!: Labels;
  public labels$: Observable<any> | undefined;
  constructor(private store: Store<any>) {}

  ngOnInit(): void {
    this.indicativeRateCountry$ = this.store.select(getIndicativeRateCountry);
    this.indicativeRateCountry$.subscribe((indicativeRateCountry) => {
      this.indicativeRateCountry = indicativeRateCountry;
    });
    this.labels$ = this.store.select(getCurrentLabelsJson);
    this.labels$.subscribe((labels) => {
      this.labels = labels.labels;
    });
  }
}
